const postFrequencyStr = {
  toastr: 'Periodicidade adicionada',
  toastr1: 'foi adicionado com sucesso',
  toastrError: 'Periodicidade já cadastrado',
  toastrError1: 'Insira outro nome'
};

export default postFrequencyStr;
